<!-- eslint-disable vue/valid-v-for -->
<template>
  <el-container>
    
    <el-header style="padding: 0; min-height: 30px;">
      <el-page-header @back="goBack()" :content="title">
      </el-page-header>
    </el-header>
    <el-main>
      <el-form ref="blogcategoryForm" :model="form" :rules="rules" label-width="120px" class="demo-ruleForm t_center"
               align="left" label-position="left">
        <el-form-item label="博客类别" prop="categoryType">
            <el-select v-model="form.categoryType" placeholder="博客类别" size="small">
            <el-option label="中文学习" value="chinese"></el-option>
            <el-option label="师资培训" value="teacher"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分类名称" prop="categoryName">
          <el-input v-model="form.categoryName" placeholder="博客分类名称"></el-input>
        </el-form-item>
        <el-form-item label="类英文名称" prop="categoryNameEn">
          <el-input v-model="form.categoryNameEn" placeholder="博客分类英文名称"></el-input>
        </el-form-item>
        <el-form-item align="center">
          <el-button @click="reset">重置</el-button>
          <el-button type="primary" @click="blogcategorySave">保存</el-button>
        </el-form-item>
      </el-form>
    </el-main>
  </el-container>
</template>

<script>
  import https from '@/https.js';
  const toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    [{'header': 1}, {'header': 2}],               // custom button values
    [{'list': 'ordered'}, {'list': 'bullet'}],
    [{'indent': '-1'}, {'indent': '+1'}],          // outdent/indent
    [{'direction': 'rtl'}],                         // text direction
    [{'size': ['small', false, 'large', 'huge']}],  // custom dropdown
    [{'header': [1, 2, 3, 4, 5, 6, false]}],
    [{'color': []}, {'background': []}],          // dropdown with defaults from theme
    [{'font': []}],
    [{'align': []}],
    ['link', 'image'],
    ['clean']

  ];
  
  export default {

    data() {
      return {
        startTimeHoursRule:'00:00:00 - 23:59:59',
        endTimeHoursRule:'00:00:00 - 23:59:59',
        loginOrgCode: '',
        blogcategoryName: '填写博客分类',
        orgEdit: false,
        showThird: false,
        loaded: false,
        form: {
          categoryName:'',
          categoryNameEn:'',
          categoryType:'',
          id: '',
          orgCode: '',
        },
        rules: {
          categoryType: [
            {required: true, message: '请选择博客类别', trigger: 'change'}
          ],
          categoryName: [
            {required: true, message: '请输入博客分类名称', trigger: 'blur'}
          ],
          categoryNameEn: [
            {required: true, message: '请输入博客分类英文名称', trigger: 'blur'}
          ]
        },
        headers: {
          Authentication: localStorage.getItem('token')
        },

      };
    },
    methods: {

      exceed(res, file) {
        console.log(res);
      },
      selectCategoryData(val) {
        if(val == undefined) {
          val = '';
        }
        let params = {
          orgCode: val
        };
        this.https.fetchPost('/courseCategoryInfo/selectListRecursion', params, 'json').then((data) => {
          this.categoryOrgOptions = [];       
          let code = data.data.code;
          let msg = data.data.msg;
          if(code == 200) {
            if(data.data.data != null) {
              this.categoryOrgOptions = data.data.data;
              for (let index = 0; index < this.categoryOrgOptions.length; index++) {
                this.array1.push({"ccId":this.categoryOrgOptions[index].ccId,"ccName":this.categoryOrgOptions[index].ccName}); 
              }
            }
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }
        }).catch(err => {
          console.log(err);
          this.$message.error('网络错误');
        });
      },
      onError (err, file, fileList) {
          console.log("err---",err);

      },

      selectItem(value){
        var aid =value;
         console.log(aid);
      },
      goBack() {
        this.$router.go(-1);
      },
      //保存资源数据
      blogcategorySave() {
        let params = this.form;
        console.log("dddd",params);
        this.$refs['blogcategoryForm'].validate((valid) => {
          if (!valid) {
            this.$message.error('请正确填写信息！');
            return false;
          } else {
            let url = '/webBlogCategory/addCategory';
            if (this.form.categoryId) {
              url = '/webBlogCategory/updateCategory';
            }
            console.log(params);
            https.fetchPost(url, params, 'json').then((data) => {
              let code = data.data.code;
              let msg = data.data.msg;
              if (code == 200) {
                this.$message({
                  message: '操作成功',
                  type: 'success'
                });
                this.$router.push('/blog/blogcategory');
              } else {
                this.$message({
                  type: 'info',
                  message: '操作失败：' + msg
                });
              }
            }).catch(err => {
                  this.$message.error('网络错误');
                }
            );
          }
        });
      },
      reset() {
        this.$refs['blogcategoryForm'].resetFields();
        // this.form.createTime = dateFormat(new Date(this.form.createTime));
      },

      changeOrg() {
        this.searchCourseType();
        this.form.id = "";
        this.form.ccId = "";
      },
    },
    created: function() {
      this.loginOrgCode = this.$store.state.orgCode;
      let dataForm = this.$route.params;
      if (dataForm.categoryId) {
        this.title = '修改博客分类信息';
        this.orgEdit = true;
        this.form = dataForm;
      } else {
        this.title = '添加博客分类信息';
      }
    },
    
  };
</script>

<style>
  .avatar-uploader {
    width: 500px;
  }
  
  .t_top {
    margin-bottom: 10px;
  }
  
  .t_center {
    width: 80%;
    margin: 0 auto;
  }
  
  .t_center1 {
    width: 100%;
    margin: 0 auto;
  }
  
  .avatar-uploader {
    width: 95%;
  }
  
  .ql-editor {
    min-height: 300px;
  }
  
  .hide .el-upload--picture-card {
    display: none;
  }
  
  .el-col-11 {
    width: 30%;
    margin-right: 0px;
    padding-right: 0px;
  }
  
  .el-upload-list__item {
    width: 50%;
  }

.avatar-uploader-icon {
  border: 1px dashed #d9d9d9 !important;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px !important;
  position: relative !important;
  overflow: hidden !important;
}
.avatar-uploader .el-upload:hover {
  border: 1px dashed #d9d9d9 !important;
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 300px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 300px;
  height: 178px;
  display: block;
}
.hide .el-upload--picture-card {
    display: none;
  }
  .avatar-uploader {
    width: 500px;
  }
  
  .t_top {
    margin-bottom: 10px;
  }
  
  .t_center {
    width: 80%;
    margin: 0 auto;
  }
  
  .t_center1 {
    width: 100%;
    margin: 0 auto;
  }
  
  .avatar-uploader {
    width: 95%;
  }
  
  .ql-editor {
    min-height: 300px;
  }
  
  .hide .el-upload--picture-card {
    display: none;
  }
  
  .el-col-11 {
    width: 30%;
    margin-right: 0px;
    padding-right: 0px;
  }
  
  .el-upload-list__item {
    width: 50%;
  }


  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;}
</style>
